import { ConceptFeedbackApi } from '../../Shared';
import { ConceptFeedback } from '../interfaces/conceptsFeedback';
import { ActionTypes } from './actionTypes';

const api = new ConceptFeedbackApi('grammar');

export const startListeningToConceptsFeedback = () => {
  return (dispatch: Function) => {
    dispatch(loadConceptsFeedback())
  };
}

export const loadConceptsFeedback = () => {
  return (dispatch: Function) => {
    api.getAll().then((data) => {
      dispatch({ type: ActionTypes.RECEIVE_CONCEPTS_FEEDBACK_DATA, data: data, });
    });
  };
}

export const loadTranslatedConceptsFeedback = (language) => {
  return function (dispatch, getState) {
    api.getAll(language).then((data) => {
      dispatch({ type: ActionTypes.RECEIVE_TRANSLATED_CONCEPTS_FEEDBACK_DATA, data: data, });
    });
  };
}

export const startConceptsFeedbackEdit = (cid: string) => {
  return { type: ActionTypes.START_CONCEPTS_FEEDBACK_EDIT, cid, };
}

export const cancelConceptsFeedbackEdit = (cid: string) => {
  return { type: ActionTypes.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, };
}

export const deleteConceptsFeedback = (cid: string) => {
  return (dispatch: Function) => {
    dispatch({ type: ActionTypes.SUBMIT_CONCEPTS_FEEDBACK_EDIT, cid, });
    api.remove(cid).then(() => {
      dispatch({ type: ActionTypes.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
      dispatch({ type: ActionTypes.DISPLAY_MESSAGE, message: 'ConceptsFeedback successfully deleted!', });
      dispatch(loadConceptsFeedback())
    }).catch((error) => {
      dispatch({ type: ActionTypes.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
      dispatch({ type: ActionTypes.DISPLAY_ERROR, error: `Deletion failed! ${error}`, });
    })
  };
}

export const submitConceptsFeedbackEdit = (cid: string, content: ConceptFeedback) => {
  return (dispatch: Function) => {
    dispatch({ type: ActionTypes.SUBMIT_CONCEPTS_FEEDBACK_EDIT, cid, });
    api.update(cid, content).then(() => {
      dispatch({ type: ActionTypes.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
      alert("Update successfully saved!");
      dispatch(loadConceptsFeedback())
    }).catch((error) => {
      dispatch({ type: ActionTypes.FINISH_CONCEPTS_FEEDBACK_EDIT, cid, });
      dispatch({ type: ActionTypes.DISPLAY_ERROR, error: `Update failed! ${error}`, });
    })
  };
}
